import axios from 'axios';
import { LoginType } from 'type';
const baseUrl = 'http://localhost:8000/api';

const api = {
   async fetchCategories() {
      return await axios.get(`${baseUrl}/category_list`);
   },
   async fetchProducts() {
      return await axios.get(`${baseUrl}/product_list`);
   },
   async fetchUserCart() {},
   async fetchProduct(id: number) {
      return await axios.get(`${baseUrl}/get_product_by_id/${id}`);
   },
   async fetchAuth(credentials: LoginType) {
      const data: LoginType = credentials;
      return await axios.post('http://localhost:8000/api/auth/token/login/', data);
   }
};

export default api;
